import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  TableCell,
  TableRow,
  Link,
} from '@material-ui/core';
import LineReceptionCustomer from '../../pages/dashBoard/lineReceptionCustomer';
import { getEnvVariable } from '../../../commonFunction/getEnv';
import UserLevel from '../../eleCommon/userLevel';

const useStyles = makeStyles((theme) => ({
  tableRow: {
    '&:nth-child(even)': {
      background: '#F3F3F3',
    },
    '&.expired': {
      background: 'rgba(216, 52, 32, 0.08)!important',
    },
    '&.Mui-selected': {
      background: `${theme.palette.primaryColor}29!important`,
    },
    '&:hover': {
      background: `${theme.palette.primaryColor}29!important`,
    },
  },
  tableTd: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: '13px',
    lineHeight: '1.6',
    letterSpacing: '0',
    padding: '6px 4px',
    textAlign: 'left',
    borderBottom: '1px solid #8C8C8C',
    height: 52,
  },
}));

/**
 * 受信日時が「〇〇分前」形式かどうかを判定する
 * @param {string} lastReceivedAt
 * @returns {boolean}
 */
const isWithinOneHour = (lastReceivedAt) => {
  if (!lastReceivedAt) return false;
  // 文字列に「分前」が含まれているか判定
  return lastReceivedAt.includes('分前');
};

export default function LineReceptionTableRowWrapper(props) {
  const { index, style, row } = props;
  const classes = useStyles();
  const { customer } = row;

  const cellCenterStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <TableRow
      hover
      tabIndex={-1}
      className={classes.tableRow}
      style={style}
    >
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '3%' }}>
        {index + 1}
      </TableCell>
      <TableCell
        className={classes.tableTd}
        style={{
          ...cellCenterStyle,
          width: '10%',
          color: isWithinOneHour(row.lastReceivedAt) ? '#ff0000' : 'inherit',
        }}
      >
        {row.lastReceivedAt}
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '5%' }}>
        {customer.id}
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '15%' }}>
        <LineReceptionCustomer
          id={customer.id}
          fullName={customer.fullName || ''}
          memberStatus={customer.memberStatusCode}
          customerStatus={customer.status}
          memberId={customer.memberId}
        />
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '10%' }}>
        <Link
          href={getEnvVariable('LINE_URL') + customer.hashCustomerId}
          target="_blank"
          color="primary"
        >
          LINEリンク
        </Link>
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '20%' }}>
        {row.user}
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '5%' }}>
        <UserLevel code={row.customer.userLevel} />
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '5%' }}>
        {customer.detachedHouseBudgetMax}
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '5%' }}>
        {customer.landBudgetMax}
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '16%' }}>
        {customer.wishArea}
      </TableCell>
      <TableCell className={classes.tableTd} style={{ ...cellCenterStyle, width: '6%' }}>
        {customer.annualIncome}
      </TableCell>
    </TableRow>
  );
}
